export const APPEND_BOOKING_PARAMS = 'APPEND_BOOKING_PARAMS';
export const CLEAR_BOOKING_PARAMS = 'CLEAR_BOOKING_PARAMS';

export const SET_BOOKINGS = 'SET_BOOKINGS';
export const RESET_BOOKINGS = 'RESET_BOOKINGS';
